import React, { Component } from "react";
import firebase from "../../utils/firebase";
import moment from "moment";
import { Link } from "react-router-dom";

import MyTable from "../../components/myTable/MyTable";

import Button from "@atlaskit/button";

import { FieldTextStateless } from "@atlaskit/field-text";
import Tabs from "@atlaskit/tabs/dist/cjs/components/Tabs";

import "./admin.css";
export default class AdminListings extends Component {
  constructor() {
    super();

    this.state = {
      listings: [],
      Title: "",
      Listing_ID: ""
    };
  }

  getListings = async param => {
    this.setState({ loading: true });
    try {
      const query = this.state[param];
      const listings = await firebase
        .firestore()
        .collection("listings")
        .where(param, "==", query)
        .get()
        .then(querySnapshot => querySnapshot.docs)
        .then(docs => docs.map(doc => doc.data()));
      this.setState({
        listings,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  fieldHandler = e => this.setState({ [`${e.target.name}`]: e.target.value });

  tabHandler = (tab, i) => this.setState({ tab: i });

  render() {
    console.log(this.state);
    return (
      <div className="admin-listings">
        <Tabs
          onSelect={this.tabHandler}
          selected={this.state.tab}
          tabs={[
            {
              label: "Listing ID",
              content: (
                <div className="admin-search">
                  <FieldTextStateless
                    className="application-admin__lid-input"
                    onChange={this.fieldHandler}
                    name="Listing_ID"
                    value={this.state.Listing_ID}
                    aria-label="Listing ID"
                    blurInputOnSelect
                    isClearable
                    appearance="default"
                    placeholder="Listing ID..."
                    shouldFitContainer
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.Listing_ID}
                    onClick={e => this.getListings("Listing_ID")}
                  >
                    Search
                  </Button>
                </div>
              )
            },
            {
              label: "Title",
              content: (
                <div className="admin-search">
                  <FieldTextStateless
                    className="application-admin__title-input"
                    onChange={this.fieldHandler}
                    name="Title"
                    value={this.state.Title}
                    aria-label="Title"
                    blurInputOnSelect
                    isClearable
                    appearance="default"
                    placeholder="Title..."
                    shouldFitContainer
                  />
                  <Button
                    isLoading={this.state.loading}
                    className="admin-search__btn"
                    appearance="primary"
                    isDisabled={!this.state.Title}
                    onClick={e => this.getListings("Title")}
                  >
                    Search
                  </Button>
                </div>
              )
            }
          ]}
        />
        <div className="admin-results">
          <MyTable
            caption="Listings"
            head={{
              cells: [
                {
                  key: "lid",
                  content: (
                    <span className="listings-admin__table-header-cell">
                      Listing ID
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "title",
                  content: (
                    <span className="listings-admin__table-header-cell">
                      Title
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                },
                {
                  key: "date",
                  content: (
                    <span className="listings-admin__table-header-cell">
                      Listing Date
                    </span>
                  ),
                  isSortable: true,
                  width: 50,
                  shouldTruncate: true
                }
              ]
            }}
            rows={this.state.listings.map((listing, i) => {
              console.log(listing);
              return {
                key: `user-admin__row_${i}`,
                cells: [
                  {
                    key: `lid`,
                    content: (
                      <Link
                        className="table-row-link"
                        to={`/listing/${listing.Listing_ID}`}
                      >
                        <span>{listing.Listing_ID}</span>
                      </Link>
                    )
                  },
                  {
                    key: `title`,
                    content: (
                      <Link
                        className="table-row-link"
                        to={`/listing/${listing.Listing_ID}`}
                      >
                        <span>{listing.Title}</span>
                      </Link>
                    )
                  },
                  {
                    key: `date`,
                    content: (
                      <span>
                        {moment(listing.Listing_Date.toDate()).format("MMM Do")}
                      </span>
                    )
                  }
                ]
              };
            })}
            emptyView={<span>No Listings</span>}
            loading={this.state.loading}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin/AdminListings.js